// extracted by mini-css-extract-plugin
export default {"appleBtn":"l5Wht","white":"ICEL5","appleIcon":"PoDKI","appleBtnContainer":"yudEU","error":"KvqOe"};